import { UseFormReturn } from "react-hook-form";

import TextEditor from "../../Global/Editors/TextEditor";
import { Table } from "react-bootstrap";
import { useGlobalData } from "../../GlobalDataProvider";

interface IProps {
  info: any;
}

const ErrorInfo = ({ info }: IProps) => {
  const global = useGlobalData();
  let txt = "?";
  try {
    txt = info.message || JSON.stringify(info);
  } catch (err) {
    txt = info?.toString();
  }
  if (txt)
    return (
      <div style={{ backgroundColor: "lightsalmon", padding: 12, marginTop: 10, marginBottom: 10 }}>
        <div>ERROR</div>
        <div>{txt}</div>
      </div>
    );
  else return <></>;
};

export default ErrorInfo;
